import React, { useState, useEffect } from 'react'
import CustomSelect from '../../../components/Entry/CustomSelect'
import ProvinceService from '../../provinces/services/Provinces'
import AgroDashboardService from '../service/AgroDashboard'

const DEFAULT_VALUES = {
    site: '',
    year: new Date().getFullYear()
}

export default function PeasantsOverviewDashboard() {
    const [site, setSite] = useState([])
    const [values, setValues] = useState({ ...DEFAULT_VALUES })
    const [peasantsCount, setPeasantsCount] = useState({
        total_planteurs: 0,
        par_genre: {
            Homme: 0,
            Femme: 0
        }
    })

    useEffect(() => {
        ProvinceService.getAgroSites().then((response) => {
            if (response?.data) {
                setSite(response?.data)
            }
        })
    }, [])

    useEffect(() => {
        AgroDashboardService.getPeasantsWithPlotsCount({
            village: values.site || undefined,
            year: values.year
        })
            .then((data) => {
                if (data) {
                    setPeasantsCount(
                        data || {
                            total_planteurs: 0,
                            par_genre: { Homme: 0, Femme: 0 }
                        }
                    )
                }
            })
            .catch((error) => {
                console.error("Une erreur s'est produite lors de la récupération du nombre de planteurs :", error)
            })
    }, [values.site, values.year])

    const getYears = () => {
        const currentYear = new Date().getFullYear()
        const options = []
        for (let i = currentYear - 4; i <= currentYear + 4; i++) {
            options.push(i)
        }
        return options
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value
        }))
    }

    // ── handleReset ───────────────────────────────────────────────
    // Vide le filtre site ; seule l'année reste à sa valeur par
    // défaut (année courante).
    const handleReset = () => {
        setValues({ ...DEFAULT_VALUES })
    }

    const formatNumber = (number) => number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')

    return (
        <div className="w-full bg-white p-4 rounded-xl border border-gray-200 flex flex-col mt-[20px]">
            <div className="flex justify-between">
                <div>
                    <p className="font-semibold text-lg">Paysans</p>
                </div>
                <div>
                    <select
                        className="bg-[#0FCB8F] w-24 h-8 rounded-md border-none text-white"
                        name="year"
                        id="year"
                        value={values.year}
                        onChange={handleChange}
                    >
                        {getYears().map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="flex  gap-[40px] mb-[15px] mt-[16px]">
                <div className="w-full">
                    <CustomSelect
                        label="Site"
                        options={site}
                        onChange={handleChange}
                        name="site"
                        value={values.site}
                        valueKey="id"
                        labelKey="name"
                    />
                </div>
                <button
                    type="button"
                    onClick={handleReset}
                    className="shrink-0 h-10 px-4 mt-[15px] rounded-md border border-[#0FCB8F] text-[#0FCB8F] bg-white hover:bg-[#0FCB8F] hover:text-white transition-colors"
                >
                    Réinitialiser
                </button>
            </div>

            <div className="flex gap-[20px] mb-[10px]">
                <div className="flex-1 bg-emerald-50 rounded-xl p-4">
                    <p className="text-xs text-gray-500">Total planteurs</p>
                    <p className="text-2xl font-bold text-emerald-700">{formatNumber(peasantsCount.total_planteurs)}</p>
                </div>
                <div className="flex-1 bg-blue-50 rounded-xl p-4">
                    <p className="text-xs text-gray-500">Hommes</p>
                    <p className="text-2xl font-bold text-blue-600">{formatNumber(peasantsCount.par_genre?.Homme)}</p>
                </div>
                <div className="flex-1 bg-pink-50 rounded-xl p-4">
                    <p className="text-xs text-gray-500">Femmes</p>
                    <p className="text-2xl font-bold text-pink-500">{formatNumber(peasantsCount.par_genre?.Femme)}</p>
                </div>
            </div>
        </div>
    )
}
